/**
 * haptics — thin wrapper around navigator.vibrate with named patterns.
 *
 * No-ops silently on desktop or browsers without vibration support
 * (Safari iOS, most desktops). Pass a duration in ms or a pattern array
 * (e.g. [10, 30, 10] = vibrate 10ms, pause 30ms, vibrate 10ms).
 */

const supported = typeof navigator !== 'undefined'
  && typeof navigator.vibrate === 'function';

function _fire(pattern) {
  if (!supported) return;
  try { navigator.vibrate(pattern); } catch (_) { /* */ }
}

// Named patterns — keep these consistent across the app so users learn
// the haptic vocabulary.
export const haptics = {
  /** Light tick for tab/page changes (12 ms). */
  tick:    () => _fire(12),
  /** Two-stage pulse for actionable taps (e.g. APPLY preset, FINISH tour). */
  confirm: () => _fire([10, 30, 20]),
  /** Heavy buzz for destructive / error events. */
  warn:    () => _fire([0, 60, 40, 60]),
  /** Soft tap for a swipe-to-dismiss completion. */
  dismiss: () => _fire(8),
};

export default haptics;
